import '../styles/info.css'
import Header_IMG from "../images/fantomgallery-home.png";
import React from 'react';

function Info() {
    return <div className="page-container">
        <div className="page-section">
        <h1>Our Mission</h1>
        <p>The mission of Fantom Gallery is to give everyone a new way to experience and collect digital art.</p>
        <h1>What is Fantom Gallery?</h1>
        <p>Fantom Gallery was the first virtual gallery on Fantom and has gone on to inspire the virtual gallery movement seen in the space today.</p>
        <p>This is a "by artists for artists" platform. The goal of this movement is to share ideas, art, and the spotlight as we grow together as a community. We believe that forum based websites will be a relic of the past and the future of websites will be truly experienced through immersion.</p>
        <h1>What is the Featured Gallery?</h1>
        <p>To display the best work the metaverse has to offer, we rotate the pieces that are displayed on a weekly basis. Our community submits and votes on pieces from across all blockchains to display quality exhibitions.</p>
        <h1>How can I display my art in the gallery?</h1>
        <p>At this time, you must be a member of The Cult to submit art to the gallery. After your art is submitted, our community will place it under review to attempt to find an exhibition that best fits your work. We also reach out to teams and artists to be featured in the gallery.</p>
        </div>
    </div>
}

export default Info;